<template>
  <a-modal
    v-model="show"
    :width="960"
    title="企业管理员设置说明"
  >
    <div>
      <About/>
    </div>

    <div slot="footer">
      <a-button type="primary" @click="show = false">好的，我知道了</a-button>
    </div>
  </a-modal>
</template>
<script>
import About from './about'

export default {
  components:{
    About
  },
  props: {
    viz: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: this.viz
    }
  },
  watch: {
    show(n) {
      this.$emit('update:viz', n)
    },
    viz(n) {
      this.show = n
    }
  }
}
</script>
<style lang="scss" scoped>
.c-tips{
    position: relative;
    .close{
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
    }
}
</style>
